import {
  Design,
  DesignBranchingEvent,
  DesignBranchingEventType
} from '../../../types';

/** Add branching event to the design. */
export function addBranchingEvent(
  design: Design,
  event: DesignBranchingEvent
): void {
  switch (event.type) {
    case DesignBranchingEventType.initBranchingMap:
    case DesignBranchingEventType.merge: {
      const branchId = event.branch_id;
      design.branchingMap ??= {};
      design.branchingMap[branchId] ??= [];
      design.branchingMap[branchId].push(event);
      break;
    }
    case DesignBranchingEventType.initBranch:
    case DesignBranchingEventType.pull:
      design.branching ??= [];
      design.branching.push(event);
      break;
    default: {
      const neverEvent: never = event;
      throw new Error(`Unknown branching event type '${(neverEvent as any).type}'.`);
    }
  }
}
